/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 23-09-2026
 *
 * De feature- en debugvlaggen uit de localconfig. Tot golf 4e kwamen ze uit de AngularJS-provider
 * (`apiProvider.flag(...)`, gelezen als `$rootScope.flag('naam')` in `canvas.html`); nu staan ze als
 * lijst in de localconfig:
 *
 *   "DL": {"vlaggen": ["normmatch_debug"]}
 *
 * **Of gewoon op het hoogste niveau, `"vlaggen": [...]`** — allebei worden ze gelezen, de `DL`-tak
 * eerst. Dat bestand is de configuratie van `sihw-ngx`, waarin de library zijn eigen instellingen
 * onder `SIHW` heeft staan; `DL` is de tegenhanger daarvan voor deze applicatie, en daar hoort
 * `quickLoad` ook al. Dat is de reden voor die tak, en meer dan netheid is het niet: er is geen
 * sleutel waarmee `vlaggen` op het hoogste niveau zou botsen. Wie hem daar neerzet krijgt hem dus
 * gewoon, want dit is een ontwikkelvoorziening en niet een plek voor regels (bijgesteld 23-09-2026,
 * nadat de vlaggenlijst bij het testen buiten de `DL`-tak belandde en stilzwijgend niets deed).
 *
 * Wat er niet in staat, staat uit. De vlaggen horen in een bestand dat buiten git blijft;
 * `localconfig.ts.example` beschrijft de vorm.
 */
import {Injectable} from '@angular/core';
import {LocalConfig} from 'sihw-ngx';

@Injectable({providedIn: 'root'})
export class VlaggenService {

    /**
     * De namen die in de localconfig aan staan: die uit de `DL`-tak, of anders die op het hoogste
     * niveau.
     */
    private readonly vlaggen: readonly string[] = new LocalConfig().$('DL.vlaggen', null) as string[]
        ?? new LocalConfig().$('vlaggen', []) as string[];

    /**
     * Staat deze vlag aan?
     */
    heeftVlag(naam: string): boolean {
        return this.vlaggen.includes(naam);
    }

    /**
     * Of de ontwikkelinformatie in beeld mag staan: het model-id onder de modeltitel en de debugregel
     * linksonder. In AngularJS was dit de aparte vlag `api.debug`, die verder alleen bepaalde of
     * `quickLoad` mocht draaien — en dat beslist de aanwezigheid van `quickLoad` zelf (kernbesluit 6).
     */
    heeftDebug(): boolean {
        return this.heeftVlag('debug');
    }
}
